import { RadioFieldCombinedProps } from './types';

const usePresenter = (props: RadioFieldCombinedProps): RadioFieldCombinedProps => {
  return props;
};

export default usePresenter;
